/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  setTimeout(function(){
    $('a[href^="#"]').click(function(){
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;

      var hd = $('.p-hd2');
      var hdSP = $('.p-hdSP');

      if(hdSP.css('display') != 'none') {
        if(hdSP) position -= hdSP.innerHeight() + 20;
      } else {
        if(hd) position -= hd.innerHeight() + 20;
      }

      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });
  }, 100);
});

//pc
$(function(){
  const $con = $('.home-con');

  if($con[0]) {
    const $ttl1 = $('.home-con__ttl1');
    let $posts, $post;
    let nextPosts = [];
    let nextPostTime = 0;

    function initTtl() {
      let cr = Math.floor(Math.random() * 3);

      $ttl1.each(function(index, el) {
        $(this).find('img').eq(cr).addClass('is-cr');
      });
    }

    function initCon() {
      let type = Math.floor(Math.random() * 3) + 1;

      let postsNum = $('.home-posts').eq(0).attr('data-num');
      if(postsNum) {
        type = postsNum;
      }

      //debug
      if(location.hash == '#type1') type = 1;
      if(location.hash == '#type2') type = 2;
      if(location.hash == '#type3') type = 3;

      $con.addClass('is-type' + type);

      setTimeout(function(){
        $con.addClass('is-show');
      }, 200);

      setTimeout(function(){
        initPost(type);
      }, 800);
    }

    function initPost(type) {
      $posts = $('.home-posts').not('.-nSP1');
      $post = $posts.find('.home-post');

      $(window).on('scroll', function(event) {
        checkPost();
      });

      checkPost();
    }

    function checkPost() {
      let winB = $(window).scrollTop() + $(window).innerHeight();

      $post.each(function(index, el) {
        const $t = $(this);
        let tC = $t.offset().top + $t.innerHeight() / 2;

        if(winB > tC && !$t.hasClass('is-wait')) {
          $t.addClass('is-wait');

          nextPosts.push($t);
        }
      });
    }

    function fadePost() {
      if(nextPosts.length > 0) {
        if(nextPostTime > 0) {
          //待機
          nextPostTime --;
        } else {
          //フェード実行
          nextPosts[0].addClass('is-show');
          nextPosts.shift();

          //次があるとき
          if(nextPosts.length > 0) {
            nextPostTime = 20;
          }
        }
      }
    }

    initTtl();
    initCon();
    setInterval(function(){
      fadePost();
    }, 10);
  }
});

//sp
$(function(){
  const $con = $('.home-con');

  if($con[0]) {
    let $posts, $post;
    let nextPosts = [];
    let nextPostTime = 0;

    function initCon() {
      setTimeout(function(){
        initPost();
      }, 800);
    }

    function initPost() {
      $posts = $('.home-posts.-nSP1');
      $post = $posts.find('.home-post');

      $(window).on('scroll', function(event) {
        checkPost();
      });

      checkPost();
    }

    function checkPost() {
      let winB = $(window).scrollTop() + $(window).innerHeight();

      $post.each(function(index, el) {
        const $t = $(this);
        let tC = $t.offset().top + $t.innerHeight() / 2;

        if(winB > tC && !$t.hasClass('is-wait')) {
          $t.addClass('is-wait');

          nextPosts.push($t);
        }
      });
    }

    function fadePost() {
      if(nextPosts.length > 0) {
        if(nextPostTime > 0) {
          //待機
          nextPostTime --;
        } else {
          //フェード実行
          nextPosts[0].addClass('is-show');
          nextPosts.shift();

          //次があるとき
          if(nextPosts.length > 0) {
            nextPostTime = 20;
          }
        }
      }
    }

    initCon();
    setInterval(function(){
      fadePost();
    }, 10);
  }
});

$(function(){
  $('.newsSingle-mokuji').each(function(index, el) {
    var mokuji = $(this).find('ul');
    var h2 = $('.newsSingle-con h2, .caseSingle-con h2');

    h2.each(function(index, el) {
      var t = $(this);
      var txt = t.html();
      var id = 'h' + (index + 1);

      mokuji.append('<li><a href="#' + id + '">' + txt + '</a></li>');
      t.attr('id', id);
    });
  });
});

$(function(){
  const $btn = $('.p-hdSP__menu button');

  if($btn[0]) {
    const $nav = $('.p-hd');
    let isOpen = false;
    let winW = $(window).innerWidth();
    let oldWinW = winW;

    $btn.on('click', function(event) {
      if(!isOpen) {
        openNav();
      } else {
        closeNav();
      }
    });

    $(window).on('resize', function(event) {
      winW = $(window).innerWidth();

      if(winW != oldWinW) {
        oldWinW = winW;

        $nav.removeAttr('style');
        isOpen = false;
      }
    });

    function openNav() {
      if(!isOpen) {
        isOpen = true;

        $btn.addClass('is-on');
        $nav.stop().slideDown(400);
      }
    }

    function closeNav() {
      if(isOpen) {
        isOpen = false;

        $btn.removeClass('is-on');
        $nav.stop().slideUp(400);
      }
    }
  }
});

$(function(){
  const $btn = $('.p-hdSP__btn button');

  if($btn[0]) {
    const $nav = $('.p-hd2');
    let isOpen = false;
    let winW = $(window).innerWidth();
    let oldWinW = winW;

    $btn.on('click', function(event) {
      if(!isOpen) {
        openNav();
      } else {
        closeNav();
      }
    });

    $(window).on('resize', function(event) {
      winW = $(window).innerWidth();

      if(winW != oldWinW) {
        oldWinW = winW;

        $btn.removeClass('is-on');
        $nav.removeAttr('style');
        isOpen = false;
      }
    });

    function openNav() {
      if(!isOpen) {
        isOpen = true;

        $btn.addClass('is-on');
        $nav.stop().slideDown(400);
      }
    }

    function closeNav() {
      if(isOpen) {
        isOpen = false;

        $btn.removeClass('is-on');
        $nav.stop().slideUp(400);
      }
    }
  }
});

$(function(){
  const $btn = $('.cat2-hd__navBg img');

  if($btn[0]) {
    const $nav = $('.cat2-nav');
    let isOpen = false;
    let winW = $(window).innerWidth();
    let oldWinW = winW;

    $btn.on('click', function(event) {
      if(!isOpen) {
        openNav();
      } else {
        closeNav();
      }
    });

    $(window).on('resize', function(event) {
      winW = $(window).innerWidth();

      if(winW != oldWinW) {
        oldWinW = winW;

        $btn.removeClass('is-on');
        $nav.removeAttr('style');
        isOpen = false;
      }
    });

    function openNav() {
      if(!isOpen) {
        isOpen = true;

        $btn.addClass('is-on');
        $nav.stop().slideDown(400);
      }
    }

    function closeNav() {
      if(isOpen) {
        isOpen = false;

        $btn.removeClass('is-on');
        $nav.stop().slideUp(400);
      }
    }
  }
});

$(function(){
  const $mokuji = $('.single-mokuji');

  if($mokuji[0]) {
    const $con = $('.single-con');
    const $ttl = $con.find('h2, h3');
    const $inner = $mokuji.find('.single-mokuji__inner2');

    let h2List = [];
    let h3List = [];

    if($ttl[0]) {
      let i = -1;
      let i2 = -1;

      $ttl.each(function(index, el) {
        const $t = $(this);

        if($t.prop('tagName') == 'H2') {
          i ++;
          h2List[i] = $t;
          h3List[i] = [];
          $t.attr('id', 'title' + (i + 1));
        } else if($t.prop('tagName') == 'H3') {
          if(i >= 0) {
            i2 ++;
            h3List[i].push($t);
            $t.attr('id', 'title' + (i + 1) + '-' + (i2 + 1));
          }
        }
      });

      for (i = 0; i < h2List.length; i++) {
        $inner.append('<p><a href="#title' + (i + 1) + '">' + h2List[i].html() + '</a></p>');
      }

      $inner.find('p').each(function(index, el) {
        const $t = $(this);

        if(h3List[index]) {
          for (i = 0; i < h3List[index].length; i++) {
            $t.append('<span><a href="#title' + (index + 1) + '-' + (i + 1) + '">' + h3List[index][i].html() + '</a></span>');
          }
        }
      });

      $mokuji.removeAttr('style');
    }
  }
});
